/**
 * أيّ موقعٍ نحن عليه: الموقع العامّ، أم نطاق شركة، أم التطوير المحلّي.
 *
 *   goyone.com / www.goyone.com   الموقع العامّ — الصفحة التعريفية والتسجيل فقط،
 *                                 ولا دخول عليه حتى لمن له جلسة.
 *   sunmed.goyone.com             نطاق الشركة — منه وحده يدخل موظفوها.
 *   localhost                     التطوير — كل شيء على نطاقٍ واحد.
 */

export function isLocalHost(): boolean {
  const host = window.location.hostname;
  return host === 'localhost' || host === '127.0.0.1';
}

/** الموقع العامّ: نطاقٌ بلا شركة. */
export function isRootSite(): boolean {
  if (isLocalHost()) return false;
  const labels = window.location.hostname.split('.');
  return labels.length <= 2 || labels[0] === 'www';
}

/** رابطُ صفحةٍ على نطاق شركة — من الموقع العامّ إلى sunmed.goyone.com. */
export function tenantUrl(slug: string, path = '/login'): string {
  const root = window.location.hostname.replace(/^www\./, '');
  return `${window.location.protocol}//${slug}.${root}${path}`;
}
